
export const arrayPushUnique = <T extends number | string>(array: Array<T>, item: T): Array<T> => {
    return Array.from(new Set([...array, item]));
};



// WEBPACK FOOTER //
// ./src/core/util/array-push-unique.ts